module.exports = __webpack_public_path__ + "img/zhiyao4.95a5909e.png";